import { render, staticRenderFns } from "./search-users.vue?vue&type=template&id=6979df28&"
import script from "./search-users.vue?vue&type=script&lang=js&"
export * from "./search-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports